import {env} from '@/config';
import {Box, Grid, IconButton, Typography, useTheme} from '@mui/material';
import {getYear} from 'date-fns';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
const {APP_VARIANT, INSTAGRAM_LINK, LINKEDIN_LINK} = env;

const Footer: React.FC = () => {
  const nowDate = new Date();
  const currentYear = getYear(nowDate);

  const {t} = useTranslation();

  const theme = useTheme();

  const isSjOne = APP_VARIANT === 'sjone';

  const url = isSjOne ? LINKEDIN_LINK : INSTAGRAM_LINK;

  const handleLinkClick = useCallback(() => {
    if (url) {
      window.open(url, '_blank');
    }
  }, [url]);

  return (
    <Grid
      container
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      flexDirection={'column'}
      sx={{
        marginTop: {xs: 2, md: 5},
        marginBottom: 2
      }}
    >
      <Typography>© {currentYear} SportJoe GmbH</Typography>
      <Box
        sx={{
          flexDirection: 'row',
          display: 'flex',
          gap: 2
        }}
      >
        <Typography
          sx={{
            marginTop: 1.2
          }}
        >
          {t('find_us_on')}
        </Typography>
        <IconButton
          onClick={handleLinkClick}
          sx={{'&:hover': {color: theme?.palette?.secondary.main || '#0077B5'}}}
        >
          {APP_VARIANT === 'sjone' ? <LinkedInIcon /> : <InstagramIcon />}
        </IconButton>
      </Box>
    </Grid>
  );
};

export default Footer;
